import {createSlice} from "@reduxjs/toolkit";
import {addAppbar, fetchActiveAppbar} from "./globalComponentsThunks";

export const activeAppbarSlice = createSlice({
    name: 'activeAppbar',
    initialState: {
        activeAppbar: null,
    },
    loading: null,
    error: null,
    reducers: {
        updateActiveAppbar: (state, action) => {
            state.activeAppbar = action.payload; // Update the active appbar with the new data
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchActiveAppbar.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchActiveAppbar.fulfilled, (state, action) => {
                state.loading = false;
                state.activeAppbar = action.payload; // Set the active appbar
            })
            .addCase(fetchActiveAppbar.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message; // Capture any error that occurs
            })
            .addCase(addAppbar.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addAppbar.fulfilled, (state, action) => {
                state.loading = false;
                state.activeAppbar = action.payload; // Update the active appbar with the newly added one
            })
            .addCase(addAppbar.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message; // Capture any error that occurs
            });
    }
})

export const {updateActiveAppbar} = activeAppbarSlice.actions;
export default activeAppbarSlice.reducer;